// extracted by mini-css-extract-plugin
export default {"wrap":"conversations_wrap__b8NA3","panel":"conversations_panel__SK+lr","list":"conversations_list__Zhzo2"};